const SDK_VERSION = '8.20.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
